import { createAction } from "redux-starter-kit";

const actions = {
  exportMessages: {
    request: createAction("admin/exportMessages/request"),
    success: createAction("admin/exportMessages/success"),
    failure: createAction("admin/exportMessages/failure"),
  },
};

export default actions;
